const GOOGLE_SCRIPT_ID = "google-identity-services";
const GOOGLE_SCRIPT_SRC = "https://accounts.google.com/gsi/client";

export const getGoogleClientId = () =>
  process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim() || "";

export const loadGoogleIdentityScript = () =>
  new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      reject(new Error("Google Sign-In is only available in the browser."));
      return;
    }

    if (window.google?.accounts?.id) {
      resolve(window.google.accounts.id);
      return;
    }

    const existingScript = document.getElementById(GOOGLE_SCRIPT_ID);

    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.google.accounts.id));
      existingScript.addEventListener("error", () =>
        reject(new Error("Failed to load Google Sign-In script.")),
      );
      return;
    }

    const script = document.createElement("script");
    script.id = GOOGLE_SCRIPT_ID;
    script.src = GOOGLE_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google.accounts.id);
    script.onerror = () => reject(new Error("Failed to load Google Sign-In script."));
    document.head.appendChild(script);
  });

export const renderGoogleSignInButton = async (container, onCredential) => {
  const clientId = getGoogleClientId();

  if (!clientId) {
    throw new Error(
      "Google Client ID is missing. Set REACT_APP_GOOGLE_CLIENT_ID in your .env file.",
    );
  }

  const googleAccounts = await loadGoogleIdentityScript();

  googleAccounts.initialize({
    client_id: clientId,
    callback: onCredential,
    auto_select: false,
  });

  container.innerHTML = "";
  googleAccounts.renderButton(container, {
    type: "standard",
    theme: "outline",
    size: "large",
    text: "signin_with",
    shape: "rectangular",
    width: 280,
  });
};
